import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Button, CssBaseline } from '@mui/material';
import Fab from '@mui/material/Fab';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
import NavSection from '../../../components/nav-section';
//
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import InstallCheck from './RaindropInstallCheck';
// image
import RaindropLogo from '../../../image/raindrop_logo.png'
// Nav
import Nav from '../nav';
// import { navLogin } from '../nav/config';
import { useNavLogin } from '../nav/config';
// ----------------------------------------------------------------------


const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 100;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100%)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: '0',
  },
}));

const UserName = styled('p')(({ theme }) => ({
  color: '#637381',
  fontWeight: '700',
}));

const StickDiv = styled('div')(() => ({
  position: 'absolute',
  right: '20px',
  display: 'flex',
  alignItems: 'center',
}));


// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const [open, setOpen] = useState(false);
  const [login, isLogin] = useState('login');
  // const startRaindrop = `Sugarpole.RD://open?user_token=${JSON.parse(sessionStorage.getItem('login_info')).user_token}`;
const navLogin = useNavLogin();
  useEffect(() => {
    if (sessionStorage.getItem('login_info')) {
      isLogin('logout')
    } else {
      isLogin('login')
      
    }
  }, []);

  const renderLoginButton = (
    <NavSection data={navLogin} style={{ display: 'flex', }} />
  );

  const navigate = useNavigate();
  const gotoMainPage = () => {
    navigate('/app', { replace: true })
  }


  // const raindropStart = () => {
  //   try {
  //   const link = document.createElement('a');
  //     link.href = "Sugarpole.RD://open?user_token=qweqweq";
  //     link.click();
  //   } catch (error) {
  //     console.log("error", error);
  //   }

  //   setTimeout(() => {
  //     // your code here
  //  }, 1000);
  // }

  return (
    <>
    <CssBaseline />
    <StyledRoot>
      <StyledToolbar>
        <Stack alignItems="Left" style={{marginLeft:'40px'}}>
          <div style={{ width: '160px' , cursor:'pointer' }} onClick={() => {gotoMainPage()}} role='presentation'><img src={RaindropLogo} alt="Raindrop_Logo" /></div>
        </Stack>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
        <Nav openNav={open} onCloseNav={() => setOpen(false)} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
          sx={{marginRight:'20px'}}
        >

          {
            login === 'logout' ?
              <>
                <UserName>{JSON.parse(sessionStorage.getItem('login_info')).user_name}</UserName>
                <NotificationsPopover />
                <AccountPopover />
               
              </> :
              login === 'login' ?
                (renderLoginButton) : null
          }
          <LanguagePopover />
          {/* <Fab  variant="extended" color="primary" size="medium" >레인드롭 실행</Fab > */}
          
        {/* <Fab  variant="extended" color="primary" size="medium" ><InstallCheck/></Fab > */}
        </Stack>
        <InstallCheck/>
          
          
      </StyledToolbar>

    </StyledRoot>
    </>
  );
}
